module.exports = __webpack_public_path__ + "../resources/images/surprised-c46b798acd690792ef343e71e52ddad6.svg";